(function(){
  if(window.LanderCart&&window.LanderCart.nativeDefault)return;
  var source=document.currentScript&&document.currentScript.dataset.productFormUrl;
  window.LanderCart={nativeBridge:true,nativeDefault:true};
  var themeCarts=new WeakMap(),pending=new WeakSet();
  function kaching(){var api=window.kachingCartApi;return api&&typeof api.openCart==='function'?api:null;}
  function restoreInputs(form){var id=form.querySelector('[name="id"]');if(id)id.disabled=false;form.querySelectorAll('[name="quantity"]').forEach(function(input){input.disabled=false;});}
  function selectCart(native,api){
    if(!themeCarts.has(native))themeCarts.set(native,native.cart);
    var original=themeCarts.get(native);
    if(!api){native.cart=original;return;}
    // Only this Studio product form delegates rendering to Kaching. The theme
    // still performs the add, error handling and loading state. No second add.
    native.cart={
      getSectionsToRender:function(){return original&&original.getSectionsToRender?original.getSectionsToRender():[];},
      setActiveElement:function(element){if(original&&original.setActiveElement)original.setActiveElement(element);},
      classList:{contains:function(){return false;},remove:function(){}},
      renderContents:function(){try{api.openCart({refetchCart:true});}catch(error){window.location.assign((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'cart');}}
    };
  }
  async function addForKaching(form,event,api){
    event.preventDefault();if(pending.has(form))return;
    var button=event.submitter||form.querySelector('[type="submit"]');
    if(button&&button.disabled)return;
    var body=new FormData(form);restoreInputs(form);pending.add(form);
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
    var notice=form.querySelector('.ls-cart-error');
    if(!notice){notice=document.createElement('p');notice.className='ls-cart-error';notice.setAttribute('role','alert');form.appendChild(notice);}notice.textContent='';
    var base=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
    try{
      var response=await fetch(base+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:body});
      var result=await response.json();
      if(!response.ok||result.status)throw Error(result.description||result.message||'Could not add these items. Please try again.');
      try{await api.openCart({refetchCart:true});}catch(error){window.location.assign(base+'cart');}
    }catch(error){notice.textContent=error.message||'Could not confirm the cart update. Check your cart before trying again.';}
    finally{pending.delete(form);restoreInputs(form);if(button){button.disabled=false;button.removeAttribute('aria-busy');}}
  }
  async function addWithBundleCode(form,event,native,api,code){
    event.preventDefault();if(pending.has(form))return;
    var button=event.submitter||form.querySelector('[type="submit"]');
    if(button&&button.disabled)return;
    var body=new FormData(form);restoreInputs(form);pending.add(form);
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
    var notice=form.querySelector('.ls-cart-error');
    if(!notice){notice=document.createElement('p');notice.className='ls-cart-error';notice.setAttribute('role','alert');form.appendChild(notice);}notice.textContent='';
    var base=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
    var added=false,codes=[code],cart=native&&(themeCarts.has(native)?themeCarts.get(native):native.cart);
    try{
      var response=await fetch(base+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:body});
      var result=await response.json();
      if(!response.ok||result.status)throw Error(result.description||result.message||'Could not add these items. Please try again.');
      added=true;
      // Preserve the customer's existing codes. Never clear cart contents or
      // silently remove a shipping/promo code when applying this product offer.
      var current=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});
      if(!current.ok)throw Error('Could not read the cart.');
      var snapshot=await current.json();
      (snapshot.discount_codes||[]).forEach(function(discount){if(discount.code&&codes.indexOf(discount.code)===-1)codes.push(discount.code);});
      var sections=cart&&cart.getSectionsToRender?cart.getSectionsToRender().map(function(section){return section.id;}):[];
      var update=await fetch(base+'cart/update.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections:sections,sections_url:window.location.pathname})});
      var updated=await update.json();
      if(!update.ok||updated.status)throw Error('Could not apply the bundle offer.');
      if(api)await api.openCart({refetchCart:true});
      else if(cart&&cart.renderContents&&sections.length&&updated.sections&&sections.every(function(id){return typeof updated.sections[id]==='string';})){
        if(cart.setActiveElement)cart.setActiveElement(button);
        if(cart.classList)cart.classList.remove('is-empty');
        cart.renderContents(Object.assign({},result,{id:result.id||(result.items&&result.items[0]&&result.items[0].id),sections:updated.sections}));
      }else window.location.assign(base+'cart');
    }catch(error){
      // After a confirmed add, use Shopify's native discount redirect. Do not
      // invite another add (which would duplicate items) if cart refresh fails.
      if(added)window.location.assign(base+'discount/'+encodeURIComponent(codes.join(','))+'?redirect='+encodeURIComponent(base+'cart'));
      else notice.textContent=error.message||'Could not confirm the cart update. Check your cart before trying again.';
    }finally{pending.delete(form);restoreInputs(form);if(button){button.disabled=false;button.removeAttribute('aria-busy');}}
  }
  function prepare(form){
    form.querySelectorAll('[data-ls-cart-field]').forEach(function(input){input.remove();});
    var offer=Array.from(form.querySelectorAll('[data-bundle-offer]')).find(function(o){var radio=o.querySelector('input[name="quantity"]');return radio&&radio.checked;});
    var choices=offer?Array.from(offer.querySelectorAll('[data-bundle-variant]')):[];
    if(choices.some(function(s){var o=s.selectedOptions[0];return !o||o.disabled||o.dataset.available==='false';}))return false;
    var id=form.querySelector('[name="id"]');
    if(id)id.disabled=false;
    form.querySelectorAll('[name="quantity"]').forEach(function(input){input.disabled=false;});
    if(!choices.length)return true;
    var original=new FormData(form),items=[];
    choices.forEach(function(s){var item=items.find(function(i){return i.id===s.value;});if(item)item.quantity++;else items.push({id:s.value,quantity:1});});
    function field(name,value){var input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;input.setAttribute('data-ls-cart-field','');form.appendChild(input);}
    items.forEach(function(item,index){
      var prefix='items['+index+']';field(prefix+'[id]',item.id);field(prefix+'[quantity]',item.quantity);
      original.forEach(function(value,key){var property=key.match(/^properties\[(.+)\]$/);if(property)field(prefix+'[properties]['+property[1]+']',value);});
      if(original.get('selling_plan'))field(prefix+'[selling_plan]',original.get('selling_plan'));
    });
    if(id)id.disabled=true;
    form.querySelectorAll('[name="quantity"]').forEach(function(input){input.disabled=true;});
    return true;
  }
  function mount(){
    document.querySelectorAll('.ls-page form').forEach(function(form){
      if(form.hasAttribute('data-preview-form')||form.querySelector('kaching-bundle')||form.closest('product-form'))return;
      if(!source&&!(window.customElements&&window.customElements.get('product-form')))return;
      // Inert template content lets Dawn constructors see the complete form.
      var template=document.createElement('template');template.innerHTML='<product-form class="product-form"></product-form>';
      var wrapper=template.content.firstElementChild,parent=form.parentNode,next=form.nextSibling;
      var button=form.querySelector('[type="submit"]');
      if(button){
        button.classList.add('product-form__submit');
        var label=button.querySelector('[data-cart-label]');if(label)label.classList.add('button-text');
        if(!form.querySelector('.loading__spinner')){var spinner=document.createElement('span');spinner.className='loading__spinner hidden';spinner.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="42 16"/></svg>';button.appendChild(spinner);}
      }
      var error=document.createElement('div');error.className='product-form__error-message-wrapper';error.hidden=true;error.setAttribute('role','alert');error.innerHTML='<span class="product-form__error-message"></span>';
      wrapper.appendChild(error);wrapper.appendChild(form);parent.insertBefore(wrapper,next);
    });
    if(source&&window.customElements&&!window.customElements.get('product-form')){
      var script=document.createElement('script');script.src=source;script.defer=true;document.head.appendChild(script);
    }
  }
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form.matches('form')||!form.closest('.ls-page')||form.hasAttribute('data-preview-form')||form.querySelector('kaching-bundle'))return;
    if(event.submitter&&event.submitter.closest('.shopify-payment-button'))return;
    var url=new URL(form.action,window.location.href);
    if(url.origin!==window.location.origin||!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname))return;
    // Retire old Studio submit listeners without cancelling normal Shopify POST.
    event.stopImmediatePropagation();
    if(!prepare(form)){event.preventDefault();return;}
    var native=form.closest('product-form'),api=kaching();
    var code=form.closest('.ls-page').dataset.bundleDiscount;
    if(code)return addWithBundleCode(form,event,native,api,code);
    if(native&&native.form===form&&typeof native.onSubmitHandler==='function'){
      selectCart(native,api);
      try{native.onSubmitHandler(event);}
      finally{restoreInputs(form);}
    }else if(api)return addForKaching(form,event,api);
    // Unsupported themes retain Shopify's standard product-form submission.
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();